module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'VehicleStateVehicle': 1,
      'VehicleStateVehicle--mobileExpanded': _vm.mobileExpanded,
      'VehicleStateVehicle--variantCompatibilityChecker': _vm.variant == 'compatibility-checker',
      'VehicleStateVehicle--variantHeaderOverlap': _vm.variant == 'header-overlap',
      'VehicleStateVehicle--variantProductOverlay': _vm.variant == 'product-overlay',
      'VehicleStateVehicle--service': _vm.variant === 'service'
    }
  }, [_c('button', {
    staticClass: "VehicleStateVehicle__MobileHeader",
    on: {
      "click": function($event) {
        _vm.mobileExpanded = !_vm.mobileExpanded
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "icon",
    staticClass: "VehicleStateVehicle__Compatiblity is-loading"
  }, [(this.compatibilty === 'Compatible') ? _c('div', {
    staticClass: "VehicleStateVehicle__Icon--Compatible"
  }, [_c('svg', {
    staticClass: "icon icon__tick",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 36 36"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.82 25.32a1 1 0 0 1-.68-.28l-6.36-6.37a1 1 0 0 1 1.35-1.34l6.36 6.36a.94.94 0 0 1 0 1.35 1 1 0 0 1-.67.28z"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.82 25.32a1 1 0 0 1-.68-.28 1 1 0 0 1 0-1.35L26.87 11a1 1 0 1 1 1.35 1.35L15.49 25a1 1 0 0 1-.67.32z"
    }
  })])]) : (this.compatibilty === 'Incompatible') ? _c('div', {
    staticClass: "VehicleStateVehicle__Icon--Incompatible"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "currentColor",
      "width": "15",
      "height": "15",
      "viewBox": "0 0 15 15"
    }
  }, [_c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M13.233 0L15 1.767 9.268 7.5 15 13.233 13.233 15 7.5 9.268 1.767 15 0 13.233 5.732 7.5 0 1.767 1.767 0 7.5 5.732z"
    }
  })])])])]) : _c('div', {
    staticClass: "VehicleStateVehicle__Icon--Compatible"
  }, [_c('svg', {
    staticClass: "icon icon__tick",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 36 36"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.82 25.32a1 1 0 0 1-.68-.28l-6.36-6.37a1 1 0 0 1 1.35-1.34l6.36 6.36a.94.94 0 0 1 0 1.35 1 1 0 0 1-.67.28z"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.82 25.32a1 1 0 0 1-.68-.28 1 1 0 0 1 0-1.35L26.87 11a1 1 0 1 1 1.35 1.35L15.49 25a1 1 0 0 1-.67.32z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "VehicleStateVehicle__MakeModel"
  }, [_vm._v("\n            " + _vm._s(_vm.vehicle.make) + " " + _vm._s(_vm.vehicle.model) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "VehicleStateVehicle__Year"
  }, [_vm._v("\n            " + _vm._s(_vm.vehicle.year) + "\n        ")]), _vm._v(" "), _c('app-icon', {
    staticClass: "VehicleStateVehicle__MobileHeaderCaret",
    attrs: {
      "icon": _vm.iconChevronUp
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "VehicleStateVehicle__Content"
  }, [_c('div', {
    staticClass: "VehicleStateVehicle__Details"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "VehicleStateVehicle__MakeModel"
  }, [_vm._v("\n                " + _vm._s(_vm.vehicle.make) + " " + _vm._s(_vm.vehicle.model) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "VehicleStateVehicle__Year"
  }, [_vm._v("\n                " + _vm._s(_vm.vehicle.year) + "\n            ")]), _vm._v(" "), (!_vm.variant === 'service') ? _c('div', {
    staticClass: "VehicleStateVehicle__Seporator"
  }, [_vm._v("\n                -\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.variant === 'service') ? _c('div', {
    staticClass: "VehicleStateVehicle__Info"
  }, [_vm._v("\n                You will only see products compatible with your vehicle.\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "VehicleStateVehicle__Actions"
  }, [_c('button', {
    staticClass: "VehicleStateVehicle__Action",
    on: {
      "click": _vm.onClear
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('collection_vehicle_bar_vehicle.clear_action')) + "\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "VehicleStateVehicle__Image"
  }, [_vm._v("\n            IMAGE"), _c('br'), _vm._v("\n            IMAGE"), _c('br'), _vm._v("\n            IMAGE"), _c('br'), _vm._v("\n            IMAGE"), _c('br'), _vm._v("\n            IMAGE\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "VehicleStateVehicle__Image"
  }, [_vm._v("\n                IMAGE"), _c('br'), _vm._v("\n                IMAGE"), _c('br'), _vm._v("\n                IMAGE"), _c('br'), _vm._v("\n                IMAGE"), _c('br'), _vm._v("\n                IMAGE\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36acedd4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/resources/scripts/components/garage/VehicleStateVehicle.vue
// module id = 1454
// module chunks = 0